var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-component" }, [
      _c("div", [
        _vm._v(
          "\n        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi architecto atque consequuntur dignissimos doloremque dolores doloribus ducimus eius expedita laudantium modi molestias, neque officia optio perspiciatis reiciendis saepe sint voluptatum?\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79bad7e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79bad7e3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/forms/image/ImageDataComponent.vue
// module id = 317
// module chunks = 0